const searchStore = {
	namespaced: true,
	state: {
    default: {
      txt1SelSrch: 'sel_gi',
      txt1WordSrch: '',
      txt2WordSrch: '',
      txt3WordSrch: '',
      evStepSrch: '1,2,3,4,5,6',
      remainSrch: '',
      date1SelSrch: '',
      date1FrdateSrch: '',
      date1TodateSrch: '',
      date2SelSrch: '',
      date2FrdateSrch: '',
      date2TodateSrch: '',
      rpSrch: '',
      rtSrch: '',
      rnSrch: '',
      rsSrch: '',
      colSortSrch: '',
      dirSortSrch: '',
      size: '20',
      pageBlock: '10',
      page: '1',
    },
    request: { // 진행 내역
      txt1SelSrch: 'sel_gi',
      txt1WordSrch: '',
      txt2WordSrch: '',
      txt3WordSrch: '',
      evStepSrch: '1,2,3,4,5,6',
      remainSrch: '',
      date1SelSrch: '',
      date1FrdateSrch: '',
      date1TodateSrch: '',
      date2SelSrch: '',
      date2FrdateSrch: '',
      date2TodateSrch: '',
      rpSrch: '',
      rtSrch: '',
      rnSrch: '',
      rsSrch: '',
      colSortSrch: '',
      dirSortSrch: '',
      size: '20',
      pageBlock: '10',
      page: '1',
    },
    result: { // 평가 결과
      txt1SelSrch: 'sel_gi',
      txt1WordSrch: '',
      txt2WordSrch: '',
      txt3WordSrch: '',
      evStepSrch: '1,2,3,4,5,6',
      remainSrch: '',
      date1SelSrch: '',
      date1FrdateSrch: '',
      date1TodateSrch: '',
      date2SelSrch: '',
      date2FrdateSrch: '',
      date2TodateSrch: '',
      rpSrch: '',
      rtSrch: '',
      rnSrch: '',
      rsSrch: '',
      colSortSrch: '',
      dirSortSrch: '',
      size: '20',
      pageBlock: '10',
      page: '1',
    },
    renewal: { // 갱신일 도래대상 업체확인
      txt1SelSrch: 'sel_gi',
      txt1WordSrch: '',
      txt2WordSrch: '',
      txt3WordSrch: '',
      evStepSrch: '1,2,3,4,5,6',
      remainSrch: '',
      date1SelSrch: '',
      date1FrdateSrch: '',
      date1TodateSrch: '',
      date2SelSrch: '',
      date2FrdateSrch: '',
      date2TodateSrch: '',
      rpSrch: '',
      rtSrch: '',
      rnSrch: '',
      rsSrch: '',
      colSortSrch: '',
      dirSortSrch: '',
      size: '20',
      pageBlock: '10',
      page: '1',
    },
	},
	getters: {
    getParamsByType: (state) => (type) => {
      if (state[type]) {
        return state[type];
      }
      return state.default;
    },
	},
	mutations: {
		SET_SEARCH_PARAMS(state, searchParams) {
      const type = searchParams.type;
      state[type].txt1SelSrch = searchParams.txt1SelSrch;
      state[type].txt1WordSrch = searchParams.txt1WordSrch;
      state[type].txt2WordSrch = searchParams.txt2WordSrch;
      state[type].txt3WordSrch = searchParams.txt3WordSrch;
      state[type].evStepSrch = searchParams.evStepSrch;
      state[type].remainSrch = searchParams.remainSrch;
      state[type].date1SelSrch = searchParams.date1SelSrch;
      state[type].date1FrdateSrch = searchParams.date1FrdateSrch;
      state[type].date1TodateSrch = searchParams.date1TodateSrch;
      state[type].date2SelSrch = searchParams.date2SelSrch;
      state[type].date2FrdateSrch = searchParams.date2FrdateSrch;
      state[type].date2TodateSrch = searchParams.date2TodateSrch;
      state[type].rpSrch = searchParams.rpSrch;
      state[type].rtSrch = searchParams.rtSrch;
      state[type].rnSrch = searchParams.rnSrch;
      state[type].rsSrch = searchParams.rsSrch;
		},
    SET_SORT_PARAMS(state, sortParams) {
      const type = sortParams.type;
      state[type].colSortSrch = sortParams.colSortSrch;
      state[type].dirSortSrch = sortParams.dirSortSrch;
    },
    SET_PAGE_PARAMS(state, pageParams) {
      const type = pageParams.type;
      state[type].page = pageParams.page;
    },
    CLEAR_ALL(state, type) {
      state[type] = { ...state.default };
    }
	},
	actions: {
		settingSearchParams({ commit }, searchParams) {
			commit("SET_SEARCH_PARAMS", searchParams);
		},
    settingSortParams({ commit }, sortParams) {
      commit("SET_SORT_PARAMS", sortParams);
    },
    settingPageParams({ commit }, pageParams) {
      commit("SET_PAGE_PARAMS", pageParams);
    },
    clearAll({ commit }, type) {
      commit("CLEAR_ALL", type);
    },
	},
};

export default searchStore;
